var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('div',{staticClass:"modal",on:{"click":_vm.hide}},[_c('img',{attrs:{"src":_vm.images[0]},on:{"click":function($event){$event.stopPropagation();}}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }